import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const FullScreenHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const close = () => setIsOpen(false);

  return (
    <header id="header">
      <nav ref={navRef} className="navbar navbar-expand-lg navbar-light bg-white" style={{ height: "85px" }}>
        <div className="container-fluid">
          <div className="footer-image-harvard" href="#"></div>

          <button
            className={"navbar-toggler " + (isOpen ? "" : "collapsed")}
            type="button"
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen((prev) => !prev);
            }}
          >
            <span className="navbar-toggler-icon"></span>
            <span className="navbar-toggler-icon"></span>
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={"collapse navbar-collapse" + (isOpen ? " show" : "")} id="navbarNavAltMarkup">
            <div className="navbar-nav ms-auto">
              <a className={`nav-link fsh-nav-link${pathname === "/" ? " active" : ""}`} href="/" onClick={close}>About</a>
              <a className={`nav-link fsh-nav-link${pathname === "/faculty" ? " active" : ""}`} href="/faculty" onClick={close}>Faculty</a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default FullScreenHeader;
